import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Rule } from 'glamor'

import { useTheme } from '../../theme'

import { Flex } from '../flex'
import { Touchable } from '../touchable'

interface IListOptionProps {
  children: React.ReactNode
  style?: Rule
  onClick?: (event: React.SyntheticEvent) => void
}

export const ListOption: React.FC<IListOptionProps> = props => {
  const theme = useTheme()
  const { children, style, onClick } = props

  const styles = {
    base: {
      padding: theme.settings.spacing.large,
      backgroundColor: theme.colors.backgrounds.main,
      width: '100%',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: theme.colors.backgrounds.mainHover,
      },
    },
  }

  return onClick ? (
    <Touchable onClick={onClick} style={[styles.base, style]}>
      {children}
    </Touchable>
  ) : (
    <Flex style={[styles.base, style]}>{children}</Flex>
  )
}

ListOption.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
}
